/*!
=========================================================
* お知らせ管理
=========================================================
*/
import React from "react";
import moment from 'moment';

import {
  Col,
} from "reactstrap";

import { Link } from 'react-router-dom';
import Request from '../../common/Request';
import InputText from '../FormParts/InputText'
import InputDatetime from '../FormParts/InputDatetime';
import InputRadio from '../FormParts/InputRadio';
import InputSelect from '../FormParts/InputSelect';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import CopyToClipWithSpan from '../FormParts/CopyToClipWithSpan';
import WithRole from '../FormParts/ButtonWithRole';
import ListBase from '../Base/ListBase';
import Format from '../../common/Format'
import Definition from '../../common/Definition';
import FormatCode from "../../common/FormatCode"
import {
  cst_information_search_mode,
} from '../../variables/codes_map';

/*
*　クラス名：
*     List   ：検索及び一覧表示用クラス
*/
class List extends ListBase {
  /*
  *　関数・変数名：
  *     default_column    ：ReactTable用のデフォルトカラム設定
  *                         下記のdataMapと連動して使う
  *  KEY 説明：
  *     Header            ：タイトル表示用
  *     accessor          ：dataMap関数とのマッピング用の名称
  *     headerClassName   ：テーブルタイトル（TH）用のCSSクラス名
  *     className         ：テーブルデータ（TD）用のCSSクラス名
  *     width             ：初期表示用横サイズ
  *     min-width         ：リサイズ時の最小サイズ
  * 　　nonTargetFilter   ：表示設定に表示しないように設定する　※省略可　
  *                          true -> しない　false ->　する
  * 　　　　　　　　　　　　　　データの固定列を設定する時に利用 
  */

  default_column = [
    { Header: 'お知らせID',accessor: 'INFORMATION__information_id',headerClassName:'text-center',className:'text-left text-top', minWidth:200},
    // { Header: '登録単位',accessor: 'INFORMATION__target_unit',headerClassName:'text-center',className:'text-left text-top', width:140},
    { Header: '件名',accessor: 'INFORMATION__subject',headerClassName:'text-center',className:'text-left text-top'},
    { Header: '掲載期間',accessor: '___JOIN_information_publish_date',headerClassName:'text-center',className:'text-left text-top', minWidth:280},
    { Header: '状態',accessor: 'INFORMATION__status',headerClassName:'text-center',className:'text-left text-top', minWidth:80},
  ];

  constructor(props) {
    super(props);

  Object.assign(this.state, {
      title: 'お知らせ管理',
      search_url: '/api/information',
      badge:false,
      column: this.default_column,
      detail_search:false,
      valid: true,
      searchData:{
        values:{
          target_datetime : moment().format("YYYY-MM-DDTHH:mm:ss"),
          search_mode : "1"
        },
        errors:{},
        requiredData:{}
      },
      show_detail_search_field:false,
      customerList : [],
      customerBranchList : [],
      displayLimitMessageFlag : 0
    });

    this.validateCallback = this.validateCallback.bind(this)
    this.search = this.search.bind(this)
  }

  componentDidMount(){
    Request.get("/api/customer",{without_limit:true}, res => {
      const customerList = res.Data.map(element=>{
        return {
          value:element.id,
          label:element.customer_name
        }
      })
      this.setState({customerList});
    })
    Request.get("/api/landmark/user_branch",{}, res => {
      const user_branch_list = res.Data.map((prop,key)=>{
        return {
            value:prop.user_branch_natural_id,
            label:prop.user_branch_name,
        }
      })
      this.setState({landmark_user_branch:user_branch_list});
    })
  }

  dataMap(data) {
    return data.map((prop, key) => {

      return {
        id: key,
        INFORMATION__information_id: (<Link target="_blank" to={"/information/detail/"+prop.information_id}>{prop.information_id}</Link>),
        // INFORMATION__target_unit: "登録単位",
        INFORMATION__subject: prop.subject,
        ___JOIN_information_publish_date: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_information_publish_date', prop)}} />,
        INFORMATION__status: FormatCode.decode("cst_information_status", prop.status)
      }
    });
  }

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  search() {
    /* ここは開発者が記述 */
    if (!this.validate()) {
        // do nothing
        return;
    }
    Request.get(this.state.search_url, 
      this.search_params()
      , res => {
        this.setState({
            data: this.dataMap(res.Data)
        });
    })
  }

  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  async validateCallback(newData, callback=()=>{}){
    console.log("newData ", newData);
    const customerParam = (this.state.customerList.findIndex(customer=>customer.value==newData.values.customer_id)>-1)
    ? {
      customer_id: newData.values.customer_id,
      customer_name: undefined
    } : {
      customer_id:undefined,
      customer_name: newData.values.customer_id
    };

    const customerBranchList = this.state.searchData.values.customer_id!=customerParam.customer_id
    ? (customerParam.customer_id
      ? await new Promise(resolve=>{
        Request.get("/api/customer/branch",{
          customer_id:customerParam.customer_id
        }, res => {
          resolve(res.Data.map(element=>{
            return {
              value:element.id,
              label:element.customer_branch_name
            }
          })) 
        })
      })
      : [])
    : this.state.customerBranchList;

    const customerBranchParam = this.state.searchData.values.customer_id==customerParam.customer_id
    ? (customerBranchList.findIndex(customer=>customer.value==newData.values.customer_branch_id)>-1)
      ? {
        customer_branch_id: newData.values.customer_branch_id,
        customer_branch_name: undefined
      }
      : {
        customer_branch_id: undefined,
        customer_branch_name: newData.values.customer_branch_id
      }
    : {
      customer_branch_id: undefined,
      customer_branch_name: undefined
    }

    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData,
        values:{
          ...newData.values,
          ...customerParam,
          ...customerBranchParam,
        }
      },
      customerBranchList
    }, ()=>callback())
    
  }

  search_field_cols() {
    return (
      <>
        <Col md="3">
          <InputSelect
              label="対象顧客"
              labelOn={true}
              name="IMFORMATION__customer_id"
              options={this.state.customerList}
              validateCallback={this.validateCallback} 
              validateType='search'
              rootData={this.state.searchData}
              isSearchable={true}
              isCreatable={true}
              searchStartLength={2}
            />
        </Col>
        <Col md="3">
          <InputSelect
            label="対象支店名"
            labelOn={true}
            key={`customer_branch_${this.state.searchData.values.customer_id}`}
            name="IMFORMATION__customer_branch_id"
            options={this.state.customerBranchList}
            validateCallback={this.validateCallback} 
            validateType='search'
            rootData={this.state.searchData}
            isSearchable={true}
            isCreatable={true}
          />
        </Col>
        <Col md="3">
          <InputText label="件名" 
            name="IMFORMATION__subject" 
            labelOn={true} 
            validateCallback={this.validateCallback} 
            validateType={"search"} 
            enterCallback={this.searchWithPageIndex} 
            rootData={this.state.searchData}
            enterSearchFlag={true} />
        </Col>
        <Col md="3"></Col>
        <Col md="3">
          <InputRadio 
            options={cst_information_search_mode}
            validateCallback={this.validateCallback} 
            rootData={this.state.searchData}
            labelOn={true}
            validateType="search"
            label="掲載期間"
            name="IMFORMATION__search_mode"
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='指定日時'
            name='IMFORMATION__target_datetime'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
            timeFormat={true}
            disabled={this.state.searchData.values.search_mode != "1"}
          />
        </Col>
      </>
    );
  }

  add_field_cols() {
    const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
    return (
      <>
        <Col md="6">
          <ButtonWithTooltipWithRole
              // button_id="BTN_M2_01_04200"
              onclick={() => { this.props.history.push('/information/add/') }}
              class="float-right btn-search btn-facebook"
              id="tmp"
              icon="fas fa-plus"
              label="追加"
              message="データを追加"
          />
        </Col>
      </>
    );
  }

  detail_search_field_btn(){
      return (<></>);
  }

  detail_search_field_cols(){
      return (<></>);
  }

  checkbox_field_cols(){
    return (
      <></>
    );
  }  

  dialog_defines() {
    return (
      <>
      {/*<DialogConfirm ref={this.dialogConfirm} />*/}
      </>
    );
  } 

}

export default List;